import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {NextDeparture} from '../DTOs/NextDeparture.component';
import {StopObject} from '../DTOs/StopObject.component';
import {LineObject} from '../DTOs/LineObject.component';
import {ItinerarioObject} from '../DTOs/ItinerarioObject.component';
import {LiveBus} from '../DTOs/LiveBus.component';
import {ObjectManager} from '../DTOs/ObjectManager.component';
import {HttpClient, HttpParams} from '@angular/common/http';

/*--------------------------------------------- Variables Globales ----------------------------------------------*/
declare var colorLineaClicada: any;
declare var nombreOrigen: any;
declare var nombreDestino: any;
declare var activeStopsGlobal: any;

declare var i18nVS: any;
declare var colorCity: any;
declare var getShape: any;
declare var getNextDepartures: any;
declare var getBusPosition: any;
declare var getRtiEstimation: any;
declare var paramPrefix: any;
declare var urlServiceInformation: string;

declare var paradaClicadaDesdeMapa: any; // Para saber si se ha clicado una parada directamente desde el mapa
declare var map: any;

declare function trackBusOnLive(lat, lon);

declare function centerMapOnStop(lat, lon);

declare function pintarRecorrido(listadoLatLong);

declare function populateMap(journeyStops);

declare function paintBusOnMap(liveBuses);

@Component({
	selector: 'app-service-information-paradas',
	templateUrl: './paradas.component.html',
	styleUrls: ['../service-information.component.css']
})

export class ParadasComponent implements OnInit {
	/*------------------------------------------------ Variables VSC -------------------------------------------------*/
	@Output() onWebServiceError: EventEmitter<boolean> = new EventEmitter<boolean>();
	@Output() onLineSelected: EventEmitter<any> = new EventEmitter<any>();

	activeLine: LineObject;

	loadingStopsClass = '';
	linesJson;
	i18nL = i18nVS;
	activeStopId = -1;

	activeStops: StopObject[] = [];
	activeItinerary: ItinerarioObject;
	activeNextDeparture: NextDeparture;
	nextDepartures: NextDeparture[] = [];
	liveBuses: LiveBus[] = [];

	busOnline = false;

	objectManager = new ObjectManager;

	// Aquí guardamos el bus que actualmente estamos viendo
	nextDepartureSearching = -1;
	nextDepartureActive = -1;

	urlAssets = urlServiceInformation;

	zeroConnections = false;

	// Control de llamadas consecutivas
	nextDepartureCallStackController = 0;
	busPositionCallStackController = 0;
	verBusesEnDirectoActivo = false;
	useRtiApi: boolean;
	companyId: any;

	/*----------------------------------------------- Funciones ----------------------------------------------------*/
	public getBackground() {
		return this._sanitizer.bypassSecurityTrustStyle(colorLineaClicada);
	}

	public setBackground(color) {
		let colorFinal = color || colorCity;
		if (!colorFinal.includes('#')) {
			colorFinal = '#' + colorFinal;
		}
		return this._sanitizer.bypassSecurityTrustStyle(colorFinal);
	}

	public comprobandoJson(res) {
		try {
			if (JSON.stringify(res) === 'null'){
				throw new Error('Retorno de las paradas inválido: ' + res);
			}
		} catch (error) {
			this.errorEnElJson('');
		}
	}

	public errorEnElJson(error) {
		console.log('Error en los WS' + error);
		this.onWebServiceError.emit(true);
	}

	/* Muestra las paradas de una línea */
	public showStops(line: LineObject) {
		this.activeStopId = -1;

		// Limpiamos el array de conexiones
		line = this.clearConnections(line);

		this.loadingStopsClass = 'invisible';
		this.activeLine = line;
		map = null;

		this.mostrarItinerario(line.getItinerarios()[0].getId(), line.getItinerarios()[0].getId_linea());
	}

	/* Esta función quitará del array de conexiones la conexión con la propia línea */
	private clearConnections(line: LineObject) {
		for (let i = 0; i < line.getItinerarios().length; i++) {
			line.getItinerarios()[i].setStops(this.clearConnectionsStep2(line.getItinerarios()[i].getStops(), line.getId()));
		}
		return line;
	}

	// Segundo paso de la función clearConnections
	private clearConnectionsStep2(stops: StopObject[], lineId) {
		const newStops: StopObject[] = stops;
		for (let i = 0; i < stops.length; i++) {
			const newConnections = [];
			let originalConnections = stops[i].getConnections();

			if (typeof originalConnections === 'undefined') {
				originalConnections = newConnections;
			}

			for (let x = 0; x < originalConnections.length; x++) {
				if (originalConnections[x].getId() !== lineId) {
					newConnections[newConnections.length] = originalConnections[x];
				}
			}

			// Se añaden las conexiones eliminando la propia línea
			newStops[i].setConnections(newConnections);
		}
		return newStops;
	}

	/* Función cuando se selecciona una línea desde las conexiones */
	public lineSelected(lineId) {
		// Recorremos el array de líneas buscando la clicada
		for (let i = 0; i < this.linesJson.length; i++) {
			if (this.linesJson[i].id === lineId) {
				this.onLineSelected.emit(this.linesJson[i]);
				break;
			}
		}
	}

	public mostrarItinerario(idItinerario: string, id_linea: string) {
		this.zeroConnections = false;
		this.verBusesEnDirectoActivo = false;
		this.activeItinerary = this.activeLine.searchForItinerario(idItinerario, id_linea);

		this.activeStops = this.activeItinerary.getStops();
		activeStopsGlobal = this.activeStops;
		nombreOrigen = this.activeItinerary.getLineHeader();
		nombreDestino = this.activeItinerary.getLineEnd();
		this.recogerShape();
		populateMap(this.activeStops);
	}

	// Esta función comprobará si desde JS se ha solicitado centrar el mapa en una parada determinada
	public centerMapOnStopRoutine() {
		let stopElementId = '';
		if (paradaClicadaDesdeMapa !== undefined && paradaClicadaDesdeMapa !== -1) {
			let paradaSeleccionada;
			for (let i = 0; i < this.activeStops.length; i++) {
				if (this.activeStops[i].getId() === paradaClicadaDesdeMapa) {
					paradaSeleccionada = this.activeStops[i];
				}
			}
			stopElementId = 'stopIdOutgoing-' + paradaClicadaDesdeMapa;
			this.centerMapOnStopTS(paradaSeleccionada);

			(<HTMLSelectElement>document.getElementById('list-route-of-stops')).scrollTop =
				(<HTMLSelectElement>document.getElementById(stopElementId)).offsetTop - 100;
		}
		paradaClicadaDesdeMapa = -1;
		setTimeout(() => this.centerMapOnStopRoutine(), 0.5);
	}

	public centerMapOnStopTS(parada) {
		if (this.activeStopId !== parada.id) {
			centerMapOnStop(parada.lat, parada.lon);
			this.recogerNextDepartures(parada.id);
			this.activeStopId = parada.id;
		}
	}

	public centerMapOnBus() {
		trackBusOnLive(this.liveBuses[0].getLat(), this.liveBuses[0].getLon());
	}

	public recogerShape() { // Recoge las líneas de un JSON
		let response;
		const params = new HttpParams()
			.set(paramPrefix + 'itineraryId', this.activeItinerary.getId())
			.set(paramPrefix + 'lineId', this.activeItinerary.getId_linea());

		this.leerDatos(getShape, params).subscribe(
			(res) => {
				this.comprobandoJson(res);
				response = res;
			},
			(err) => this.errorEnElJson(err),
			() => this.pintarShape(response)
		);
	}

	public recogerNextDepartures(idStopSelected) { // Recoge las líneas de un JSON
		this.nextDepartures = [];
		this.zeroConnections = false;
		let response;
		const params = new HttpParams()
			.set(paramPrefix + 'stopId', idStopSelected)
			.set(paramPrefix + 'itineraryId', this.activeItinerary.getId());

		// Control de llamadas
		this.nextDepartureCallStackController++;
		const callStackController = this.nextDepartureCallStackController;

		this.leerDatos(getNextDepartures, params).subscribe(
			(res: any) => {
				this.comprobandoJson(res);
				response = res;
			},
			(err) => this.errorEnElJson(err),
			() => {
				this.pintarNextDepartures(response, callStackController);
				if(this.useRtiApi && this.nextDepartures.length !== 0) {
					this.recogerEstimacion();
				} 
			}
		);
		
	}

	public recogerEstimacion() {
		let lineId = this.linesJson[0].itinerarios[0].id_linea;
		for (let i = 0; i < this.nextDepartures.length; i++) {
			//companyId, lineId, expeditionId
			const rtiParams = new HttpParams()
				.set(paramPrefix + 'companyId' , this.companyId)
				.set(paramPrefix + 'lineId', lineId)
				.set(paramPrefix + 'expeditionId', this.nextDepartures[i].getExpevisit().getExpeditionId());
			this.leerDatos(getRtiEstimation, rtiParams).subscribe(
				(res: any) => {
					this.comprobandoJson(res);
					if(res[0] !== undefined) {
						// Formato fecha 2024-07-19T06:11:09.665Z
						let fullDate = new Date(res[0].itinerary[0].arrivalEstimated);
						let estimationTime = fullDate.toLocaleTimeString();
						this.nextDepartures[i].setEstimationTime(estimationTime);
					}
				},
				(err) => this.errorEnElJson(err)
			)
		}
	}

	public leerDatos(url: string, params: HttpParams) {
		return this.httpclient.post<any>(url, params);
	}

	public pintarShape(response: any) {
		if (response.geo) {
			pintarRecorrido(response.geo);
		} else {
			console.log('Error al obtener la shape del itinerario');
		}
	}

	public pintarNextDepartures(nextDeparturesResponse, callStackController) {
		if (callStackController < this.nextDepartureCallStackController || nextDeparturesResponse == null) {
			return;
		}
		if (this.nextDepartures.length === 0) {
			this.zeroConnections = true;
		}
		this.nextDepartures = this.objectManager.getNextDeparturesFromJson(nextDeparturesResponse);
	}

	public pintarStopsOfLine(response) {
		this.activeStops = this.objectManager.getStopsArrayFromJson(response[0].outgoing.stops);
	}

	// Control de llamadas
	public getBusPositionFunction(nextDeparture: NextDeparture) {
		this.activeNextDeparture = nextDeparture;

		this.nextDepartureSearching = nextDeparture.getId();
		this.nextDepartureActive = -1;

		const params = new HttpParams()
			.set(paramPrefix + 'lineId', this.activeItinerary.getId_linea())
			.set(paramPrefix + 'itineraryId', this.activeItinerary.getId());

		let response;

		this.busPositionCallStackController++;
		const callStackController = this.busPositionCallStackController;

		this.leerDatos(getBusPosition, params).subscribe((res) => {
			this.comprobandoJson(res);
			response = res;
		}, (err) => this.errorEnElJson(err), () => this.setBusPositionFunction(response, callStackController));
	}

	public setBusPositionFunction(response, callStackController) {
		if (callStackController < this.busPositionCallStackController) {
			return;
		}
		this.verBusesEnDirectoActivo = false;
		this.nextDepartureActive = this.nextDepartureSearching;

		try {
			this.liveBuses = this.objectManager.getLiveBusesArrayFromJson(response);
			if (this.liveBuses.length !== 0) {
				this.busOnline = true;
				paintBusOnMap(this.liveBuses);
				this.verBusesEnDirectoActivo = true;
				/* Esto se activara cuando los servicios vayan mejor
				this.verBusEnDirecto();
				setTimeout(() => this.verBusEnDirecto(), 2000);
				*/
			} else {
				this.busOnline = false;
			}
		} catch (error) {
			this.liveBuses = [];
		}
	}

	public verBusEnDirecto() {
		if (this.verBusesEnDirectoActivo) {
			this.getBusPositionFunction(this.activeNextDeparture);
		}
	}

	/*--------------------------------------------- Eventos ------------------------------------------------------*/
	ngOnInit() {
		this.centerMapOnStopRoutine();
	}

	/*--------------------------------------------- Constructores ------------------------------------------------*/
	constructor(private httpclient: HttpClient, private _sanitizer: DomSanitizer) {
	}
}



// WEBPACK FOOTER //
// ./src/app/paradas/paradas.component.ts